/**
 * V37.32 — Moteur de calcul DOMIUM cote frontend.
 *
 * Reproduit la formule de `calculer_contribution_domium` du backend
 * (services/domium_subscription_service.py) pour permettre un
 * affichage live « avant / apres » dans le panel admin sans aller-retour
 * reseau.
 *
 * Formule :
 *   taux_base = (tranches actives ? tranche.taux : config.taux_base)
 *   taux_eff  = taux_base * c_terr * c_op * c_bat
 *   red_tot   = (mesures_prevention ? reduction_prevention : 0)
 *             + reduction_ess * part_entreprises_ess / 100
 *   taux_fin  = clamp(taux_eff * (1 - red_tot), taux_min, taux_max)
 *   contrib   = cout_ht * taux_fin
 */

function getTauxForMontant(montant, config) {
  if (!config.tranches_taux_actives) return Number(config.taux_base) || 0;
  const tranches = config.tranches_taux || [];
  if (!tranches.length) return Number(config.taux_base) || 0;
  for (const t of tranches) {
    const smin = Number(t.seuil_min) || 0;
    const smax = t.seuil_max == null ? null : Number(t.seuil_max);
    if (smax == null) {
      if (montant >= smin) return Number(t.taux) || 0;
    } else if (montant >= smin && montant <= smax) {
      return Number(t.taux) || 0;
    }
  }
  return Number(config.taux_base) || 0;
}

export function computeContribution({
  cout_construction_ht,
  territoire,
  type_operation,
  type_batiment,
  mesures_prevention = false,
  part_entreprises_ess = 0,
}, config) {
  const cout = Number(cout_construction_ht) || 0;
  if (cout <= 0) {
    return {
      taux_base_pct: 0, coeff_territoire: 0, coeff_operation: 0,
      coeff_batiment: 0, taux_effectif_pct: 0, reduction_totale_pct: 0,
      taux_final_pct: 0, contribution_ht: 0,
    };
  }
  const cT = Number(config?.coeff_territoire?.[territoire] ?? 1.15);
  const cO = Number(config?.coeff_operation?.[type_operation] ?? 1.0);
  const cB = Number(config?.coeff_batiment?.[type_batiment] ?? 1.0);
  const tauxBase = getTauxForMontant(cout, config);
  const tauxEff = tauxBase * cT * cO * cB;
  const redPrev = mesures_prevention ? Number(config?.reduction_prevention ?? 0) : 0;
  const redEss = Number(config?.reduction_ess ?? 0) * Number(part_entreprises_ess || 0) / 100;
  const redTot = redPrev + redEss;
  const tauxMin = Number(config?.taux_min ?? 0);
  const tauxMax = Number(config?.taux_max ?? 1);
  let tauxFinal = tauxEff * (1 - redTot);
  if (tauxFinal < tauxMin) tauxFinal = tauxMin;
  if (tauxFinal > tauxMax) tauxFinal = tauxMax;
  const contribution = cout * tauxFinal;
  return {
    taux_base_pct: tauxBase * 100,
    coeff_territoire: cT,
    coeff_operation: cO,
    coeff_batiment: cB,
    taux_effectif_pct: tauxEff * 100,
    reduction_totale_pct: redTot * 100,
    taux_final_pct: tauxFinal * 100,
    contribution_ht: contribution,
    was_clamped: tauxEff * (1 - redTot) > tauxMax || tauxEff * (1 - redTot) < tauxMin,
  };
}
